import type { Blueprint } from "./types";

const DEFAULT_W = 2000; // cm; user can rescale later

function imageToBlueprint(dataUrl: string, name: string): Promise<Blueprint> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const ratio = img.height / img.width;
      const w = DEFAULT_W;
      const h = DEFAULT_W * ratio;
      resolve({ src: dataUrl, name, x: 0, y: 0, w, h, rotation: 0, opacity: 0.5, locked: false });
    };
    img.onerror = reject;
    img.src = dataUrl;
  });
}

function readAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result));
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

async function renderPdfFirstPage(file: File): Promise<string> {
  const pdfjsLib = await import("pdfjs-dist");
  const workerUrl = (await import("pdfjs-dist/build/pdf.worker.min.mjs?url")).default;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (pdfjsLib as any).GlobalWorkerOptions.workerSrc = workerUrl;
  const buf = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: buf }).promise;
  const page = await pdf.getPage(1);
  const viewport = page.getViewport({ scale: 2 });
  const canvas = document.createElement("canvas");
  canvas.width = viewport.width;
  canvas.height = viewport.height;
  const ctx = canvas.getContext("2d")!;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  await page.render({ canvasContext: ctx, viewport, canvas } as any).promise;
  return canvas.toDataURL("image/png");
}

export async function fileToBlueprint(file: File): Promise<Blueprint> {
  const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
  if (isPdf) {
    const dataUrl = await renderPdfFirstPage(file);
    return imageToBlueprint(dataUrl, file.name);
  }
  const dataUrl = await readAsDataUrl(file);
  return imageToBlueprint(dataUrl, file.name);
}